import React from 'react';
import pageStyle from '../StockPage/StockPage.module.css';
import style from './InsiderTrades.module.css';

/**
 * SSR + first client paint placeholder. No hooks, SWR, Chart.js, or InfoTooltip (useId).
 */
const InsiderTradesStaticShell = () => (
  <div
    className={`${pageStyle.flexGrid} ${style.dualCards}`}
    data-testid="insider-congress-trades"
  >
    <div className={style.card}>
      <h3 className={style.headline}>Insider Trades</h3>
      <p className={style.noData}>Loading insider trades…</p>
    </div>
    <div className={style.card}>
      <h3 className={style.headline}>Congress Trades</h3>
      <p className={style.noData}>Loading congress trades…</p>
    </div>
  </div>
);

export default InsiderTradesStaticShell;
